export default __webpack_public_path__ + "static/RegistroAgentes-6ad007d17767c46e635fb48b54eaf2c3.pdf";